import { styled } from "styled-components";

export const NumberTransferSectionWrapper = styled.div<{
  $altStyling?: boolean;
}>`
  width: 100%;
  background: ${({ theme, $altStyling }) =>
          $altStyling
                  ? `linear-gradient(to bottom, ${theme.colors.primary[950]} 200px, ${({ theme }) => theme.colors.base} 0)`
                  : theme.colors.base};
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
`;

export const NumberTransferSectionContainer = styled.div`
  z-index: 1;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  padding: 0 24px 48px 24px;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
`;

export const Arch = styled.div`
  z-index: 0;
  color: ${({ theme }) => theme.colors.base};
  overflow-x: hidden;
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: -1px;

  @media (min-width: 2400px) {
    display: none;
  }
`;

export const Disclaimer = styled.div`
  color: ${({ theme }) => theme.colors.default[600]};
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  gap: 12px;

  & > a {
    color: ${({ theme }) => theme.colors.primary.default};
  }
`;
